<template lang="pug">
    v-card
        //loading-dialog(:loading="loadingData")
        //crud-data-table.px-5.mt-5(
            v-if="!loadingData"
            :service="serviceTable" 
            :headers="headerTable" 
            :deleteButton="()=>{true}" 
            noAutoWidth 
            @show="submitShow($event)" 
            noSearchBox
            :filters="[]"
            noActions
            )
        model-data-table(
            loading-text="Cargando notas de crédito..."
            no-data-text="Sin notas de crédito."
            no-search
            no-remove
            ref="table"
            v-bind="tableProps"
            @detail="submitShow"
            )
        nc-detail-dialog(
          :creditNoteId="creditNoteId"
          :creditNoteModel="CreditNoteMdl"
          read-only
          ref='creditNoteDialog2'
        )
        //- detail-dialog(ref="invoiceReceivableDialog" :invoiceId="invoiceId" readOnly)
</template>

<script>
//-
import { ModelDataTable } from '@/components/reusable_components/next'
import SlCreditNote from '../../../models/Sale/SlSaleCreditNote'
import TableHeaders from './headers/creditNote'
import DetailDialog from '@/components/dialogs/invoice/InvoiceDetailDialog'
import DetailCreditNoteDialog from '@/components/reusable_components/DocumentDetail/creditNote/CreditNoteDetail'
//-
export default {
    name: 'customer-historic-invoice',
    props: {},
    data: function() {
        return {
            headerTable: TableHeaders,
            customerId: null,
            creditNoteId:null,
            CreditNoteMdl:SlCreditNote

        }
    },
    computed: {
        tableProps() {
            return {
                service: SlCreditNote,
                paramFilter: {
                    sl_customer_id: this.customerId,
                },
                headers: this.headerTable,
                filters: [
                    {
                        name: 'number',
                        type: 'text-field',
                        props: {
                            label: 'Folio',
                        },
                        flex: {
                            sm6: true,
                            lg5: true,
                        },
                    },
                ],
            }
        },
    },
    methods: {
        /**
         */
        setCustomerId() {
            this.customerId = this.$route.params.id
        },
        /**
         *
         */
        submitShow(event) {
            console.log(event,'event')
            this.creditNoteId = event.item.id
            this.$refs.creditNoteDialog2.open = true
        },
    },
    watch: {},
    components: {
        'model-data-table': ModelDataTable,
        'nc-detail-dialog':DetailCreditNoteDialog,
    },
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    beforeMount: function() {
        this.setCustomerId()
    },
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss"></style>
